import { Close } from '@mui/icons-material';
import {
  Box,
  Modal,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
  IconButton,
} from '@mui/material';
import { CloseCircle, TickCircle } from 'iconsax-react';

const ModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 610,
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.palette.secondary.surface_14
      : theme.palette.background.paper,
  border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.secondary.neutral_30 : theme.palette.secondary.neutral_90}`,
  padding: theme.spacing(14, 28.5),
  textAlign: 'center',
  borderRadius: theme.spacing(4),
  maxHeight: '95vh',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  '&': {
    MsOverflowStyle: 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,
  },
  '&:focus': {
    outline: 'none',
  },
  [theme.breakpoints.down('md')]: {
    width: '90%',
    padding: theme.spacing(6),
  },
}));
const ModalIcon = styled('img')(({ theme, widthCustom }) => ({
  width: widthCustom,
  margin: '0px auto 2rem auto',
  display: 'block',
}));
const CloseIcon = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '20px',
  right: '10px',
  fontSize: theme.spacing(6),
}));

const FailedBox = styled(Box)(({ theme }) => ({
  backgroundColor: '#F7D4D3',
  color: '#B12425',
  padding: theme.spacing(2, 6),
  marginBottom: theme.spacing(8),
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(2),
  fontWeight: 500,
  fontSize: theme.spacing(5),
  borderRadius: theme.spacing(1.25),
}));

const LayoutModal = ({
  open = false,
  handleClose,
  route = '',
  children,
  icon = '',
  iconWidth = '128px',
  sx = {},
  disabledIcon = false,
  statusBoxType = '',
}) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Modal
      open={open}
      sx={{
        '.MuiModal-backdrop': {
          backgroundColor: 'rgba(27, 27, 31, 0.2)',
          backdropFilter: 'blur(2.5px) ',
        },
      }}
      onClose={
        handleClose
          ? handleClose
          : () => {
              return;
            }
      }
    >
      <ModalBox sx={sx}>
        {statusBoxType ? (
          statusBoxType === 'email-verification-failed' ? (
            <FailedBox>
              <CloseCircle />
              Your token has been expired
            </FailedBox>
          ) : null
        ) : null}
        {!disabledIcon ? (
          <ModalIcon
            widthCustom={iconWidth}
            src={
              icon
                ? icon
                : `/static/img/${theme.palette.mode === 'dark' ? 'magicalapi_logo_white' : 'magicalApi-icon'}.png`
            }
          />
        ) : null}

        {handleClose ? (
          <CloseIcon onClick={handleClose}>
            <Close />
          </CloseIcon>
        ) : null}
        {children}
      </ModalBox>
    </Modal>
  );
};
export default LayoutModal;
